import { h, Component, Fragment } from 'preact';
import {Form, Container} from 'components/elements' 
import {connect} from 'react-redux'
import style from './style.less'
import {FASpinner,FAClock} from 'components/elements/FontAwesome'

@Form
@connect((state)=>({
	...state
}))
export default class WaitingRoom extends Component {
	constructor(){
        super()
    }

    get waitingRoom(){
        return this.props.waitingRoom || []
    }

    get appointments(){
        return this.props.appointments || {}
    }

    get appointmentLength(){
        let appointmentType = Object.values(this.props.appointmentTypes || {})[0]
        if(appointmentType){
            return (appointmentType.durations || '').split(",")[0]
        }
        return 0
    }

    get administrators(){
        let administrators = Object.values(this.props.administrators)
        return administrators.filter((admin)=>{
            return !admin.isWaitingRoom
        })
    }

    get queue(){
        return _.flatten(this.waitingRoom)
    }

    get isInQueue(){
        let appointmentIDs = Object.keys(this.appointments)
        if(_.intersection(appointmentIDs, this.queue).length > 0){
            return true
        }
        return false
    }

    get positionInQueue(){
        for(let appointmentID of Object.keys(this.appointments)){
            if(this.queue.includes(appointmentID)){
                return this.queue.indexOf(appointmentID) + 1
            }
        }
        return -1
    }

    get inQueueWaitTime(){
        if(this.waitingRoom.length > 1){
            let columnCount = this.waitingRoom[0].length
            const row = parseInt(this.positionInQueue / columnCount) + 1
            
            return  row * this.appointmentLength
        }else{
            return this.appointmentLength
        }
    }
    get notInQueueWaitTime(){
        if(this.waitingRoom.length > 1){
            let rowCount = this.waitingRoom.length
            if(this.administrators.length == this.waitingRoom[0].length){
                rowCount = rowCount + 1
            }
            return rowCount * this.appointmentLength
        }else{
            return this.appointmentLength
        }
    }

    hourlyWaitTime(value){
        return {
            hours: parseInt(value / 60),
            minutes: value - parseInt(value / 60) * 60
        }
    }

	render(){
		return (
            <div class={style.waitingRoom}>
                {!this.props.closed && (
                    <span>
                        <div class={style.spinnerContainer}>
                            {this.props.spinner ? (
                                <FASpinner />
                            ) : (
                                <FAClock />
                            ) }
                        </div>
                        {this.queue.length == 0 ?
                            <span>
                                There is no one ahead of you!
                            </span>
                        :
                            (this.isInQueue ?
                                (this.positionInQueue > 1 ?
                                    <span>
                                        <span class={style.waitTime}>
                                            Your estimated wait time is {this.inQueueWaitTime > 59?(
                                                <Fragment>
                                                    <span class={style.waitingRoomParam}>
                                                        {this.hourlyWaitTime(this.inQueueWaitTime).hours}
                                                    </span> hours, and {this.hourlyWaitTime(this.inQueueWaitTime).minutes} minutes.
                                                </Fragment>
                                            ):(
                                                <Fragment>
                                                    <span class={style.waitingRoomParam}>
                                                        {this.inQueueWaitTime}
                                                    </span> minutes. 
                                                </Fragment>
                                            )}
                                        </span>
                                        <span class={style.waitPosition}>
                                            There {this.positionInQueue == 2?"is":"are"} <span class={style.waitingRoomParam}>{this.positionInQueue - 1}</span> {this.positionInQueue == 2?"person":"people"} ahead of you.
                                        </span>
                                    </span>
                                :
                                    <span>
                                        You're next in line!
                                    </span>
                                )
                            :
                                <span>
                                    <span class={style.waitTime}>
                                        The estimated wait time is {this.notInQueueWaitTime > 59?(
                                            <Fragment>
                                                <span class={style.waitingRoomParam}>
                                                    {this.hourlyWaitTime(this.notInQueueWaitTime).hours}
                                                </span> hours, and {this.hourlyWaitTime(this.notInQueueWaitTime).minutes} minutes.
                                            </Fragment>
                                        ):(
                                            <Fragment>
                                                <span class={style.waitingRoomParam}>
                                                    {this.notInQueueWaitTime}
                                                </span> minutes. 
                                            </Fragment>
                                        )}
                                    </span>
                                    <span class={style.waitPosition}>
                                        There {this.queue.length == 1?"is":"are"} <span class={style.waitingRoomParam}>{this.queue.length}</span> {this.queue.length == 1?"person":"people"} in line.
                                    </span>
                                </span>
                            )
                        }
                    </span>
                )}
            </div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/groups/WaitingRoom/index.js